import styled, {css} from 'styled-components'

export const StyledEmptySearch = styled('div')(
    ({theme: {spacing, palette, typography}}) => css`
        width: 100%;
        background: ${palette.neutral.white};
        border-radius: 12px;

        padding: ${spacing * 10}px;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        height: 100%;

        h3 {
            ${typography.textMd};
            font-weight: 600;
            color: ${palette.neutral['900']};
            margin-top: ${spacing * 4}px;
        }
        h4 {
            ${typography.textSm};
            margin: ${spacing}px 0 ${spacing * 6}px;
        }
    `
)
